// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilterIndicator-module_label_box_v8UwW {
  color: var(--uu-granite-peak);
  display: flex;
  align-items: start;
  font-size: smaller;
}

.FilterIndicator-module_close_popover_button_tG0Su {
  position: absolute;
  top: 2px;
  right: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Misc/FilterIndicator.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ","sourcesContent":[".label_box {\n  color: var(--uu-granite-peak);\n  display: flex;\n  align-items: start;\n  font-size: smaller;\n}\n\n.close_popover_button {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label_box": `FilterIndicator-module_label_box_v8UwW`,
	"close_popover_button": `FilterIndicator-module_close_popover_button_tG0Su`
};
export default ___CSS_LOADER_EXPORT___;
